module.exports = __webpack_public_path__ + "4d0ac17c01f011dd8e6aa6f6c49f55b5.png";